import {qs} from '../qs'

const BASE_PATH = '/run/pmf/preanalysis'

export default {
  termInput: query => ({
    url: `/run/pmf/input`,
    method: 'POST',
    data: query
  }),
  stat: query => ({
    url: `${BASE_PATH}/stat${qs(query, '?')}`,
    method: 'GET'
  }),
  updateCat: data => ({
    url: `${BASE_PATH}/cat`,
    method: 'PUT',
    data
  }),
  concTimeSeries: query => ({
    url: `${BASE_PATH}/conc-unc${qs(query, '?')}`,
    method: 'GET'
  }),
  baseRun: data => ({
    url: `/run/pmf/baserun`,
    data,
    method: 'POST'
  }),
  status: id => ({
    url: `/run/pmf/baserun/status?id=${encodeURIComponent(id)}`,
    method: 'GET'
  }),
  residual: id => ({
    url: `/run/pmf/baserun/residual?id=${encodeURIComponent(id)}`,
    method: 'GET'
  }),
  timeSource: id => ({
    url: `/run/pmf/baserun/time-source?id=${encodeURIComponent(id)}`,
    method: 'GET'
  }),
  factorSource: id => ({
    url: `/run/pmf/baserun/factor-source?id=${encodeURIComponent(id)}`,
    method: 'GET'
  }),
  getLog: query => ({
    url: `/run/pmf/log${qs(query, '?')}`,
    method: 'GET'
  })
}



// WEBPACK FOOTER //
// ./src/apis/modules/PMFAnalysis.js